import { render, staticRenderFns } from "./BookingDirection.vue?vue&type=template&id=8243810e&scoped=true"
import script from "./BookingDirection.vue?vue&type=script&lang=js"
export * from "./BookingDirection.vue?vue&type=script&lang=js"
import style0 from "./BookingDirection.vue?vue&type=style&index=0&id=8243810e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8243810e",
  null
  
)

export default component.exports